import React from 'react';
import PropTypes from 'prop-types';
import {Link} from '@homeaway/react-localization-components';
import cnames from 'classnames';
import {getDisplayName} from '../../common/constants';
import {CARD_TYPE_CNAME} from '../../common/constants';

const wrappedComponentType = {
    /** Callback to be called when the user clicks on the card */
    onClick: PropTypes.func,
    /** Callback to be called when the user clicks on the card using right button */
    onContextMenu: PropTypes.func,
    /** Callback to be called when the card gets focused */
    onFocus: PropTypes.func,
    /** Url where the user will navigate to when clicking on the card */
    clickUrl: PropTypes.string.isRequired,
    /** Class to be added to the card anchor */
    className: PropTypes.string,
    /** Rel attribute to specify the relationship between the homepage and the external links */
    relUrl: PropTypes.string,
    /** Native target attribute for links */
    target: PropTypes.oneOf(['_self', '_blank']),
};

const wrappedComponentProps = {
    onClick: () => {},
    onContextMenu: () => {},
    onFocus: () => {},
    target: '_self',
};

const withLink = (CardComponent) => {
    const wrappedComponent = ({
        clickUrl,
        target,
        className,
        onClick,
        onContextMenu,
        onFocus,
        relUrl,
        ...rest
    }) => {
        const linkProps = {
            href: clickUrl,
            target,
            className: cnames(CARD_TYPE_CNAME, className),
            onClick,
            onContextMenu,
            onFocus,
            rel: relUrl,
        };

        return (
            <Link {...linkProps}>
                <CardComponent {...rest} />
            </Link>
        );
    };

    wrappedComponent.propTypes = wrappedComponentType;
    wrappedComponent.defaultProps = wrappedComponentProps;
    wrappedComponent.displayName = `withLink(${getDisplayName(CardComponent)})`;

    return wrappedComponent;
};

withLink.propTypes = {
    /** CardComponent to be wrapped with a Link */
    CardComponent: PropTypes.element,
};

export default withLink;
